(ns z-eines.client
  (:require
   [z-eines.impl :as i]
   [frontend.logging :as logging]))

;;
;; Defaults:
;;

(def default-options
  {:on-message identity
   :on-connect identity
   :on-close   identity
   :on-error   identity
   :format     :transit+json})

;;
;; Send message to server:
;;

(def READY_STATE_OPEN 1)

(defn authenticated!
  [auth-ok?]
  (swap! i/state assoc :authenticated? auth-ok?)
  (:authenticated? @i/state))

(defn send!
  ([message] (send! message nil nil))
  ([message response-fn] (send! message response-fn 50000))
  ([message response-fn timeout]
   (send! message response-fn timeout false))
  ([message response-fn timeout auth?]
   (let [socket (:socket @i/state)
         ready-state (when socket
                       (.-readyState socket))]
     (if (and (= ready-state READY_STATE_OPEN)
              (or auth?
                  (:authenticated? @i/state)))
       (let [message (assoc message :type :eines.type/request)
             message (if response-fn
                       (assoc-in message
                                 [:headers :eines/rsvp-request-id]
                                 (i/rsvp-request-id response-fn timeout))
                       message)
             packed (i/pack message)]
         #_(logging/warn "eines.client/send! : " (:id message)
                         " --> " (get-in message [:headers :eines/rsvp-request-id]))
         (.send socket packed))
       (do
         (if (= ready-state READY_STATE_OPEN)
           (logging/info "eines.client/send!: socket is not AUTHENTICATED - trying again in 200ms")
           (logging/info "eines.client/send!: socket is not OPEN - trying again in 200ms"))
         (js/setTimeout (fn []
                          (send! message response-fn timeout auth?))
                        200))))))

;;
;; Init WebSocket:
;;

(defn init!
  [opts]
  (swap! i/state i/reset-state (merge default-options opts))
  ;TODO: try to reconnect
  (i/connect!))

;;
;; Helpers:
;;

